var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":_vm.printChecklist}},[_c('b',[_vm._v("Print")])])}
var staticRenderFns = []

export { render, staticRenderFns }